import './Dyno.css';
import RightArrow from '../../images/right-arrow.svg';
import DivyFeature from '../../images/divy-feature.png';
import DivyFeatureVisual from './DivyFeatureVisual';

const Dyno = () => {
  return (
    <div className="dyno-container" id="divy-section">
      <div className="dyno-columns">
        <div className="dyno-left-column">
          <div className="dyno-row">
            <span className="dyno-text">Divy</span>
            <span className="dyno-description"> splits your orders into multiple orders with your predefined rules. Have a better fulfillment experience with customized rules.</span>
          </div>
          <div className="dyno-second-row">
            <span className="dyno-text-secondary">Split process can be done manually or automatically. It can also be customized to your needs. Just let us know what you need.</span>
            <button className="dyno-button" onClick={() => {
              window.open('https://apps.shopify.com/splinter-order-split', '_blank');
            }}>
              <div className="dyno-button-text">Get started</div>
              <img src={RightArrow} alt="right arrow" className="arrow-icon" />
            </button>
          </div>
        </div>
        <div className="dyno-right-column">
          <DivyFeatureVisual />
        </div>
      </div>
    </div>
  );
};

export default Dyno;